export const heroContentByMode = {
  all: {
    eyebrow: "Estética e nutrição • cuidado completo",
    title: "Beleza, saúde e autoestima em uma experiência completa.",
    description:
      "Uma abordagem que une estética e nutrição para cuidar de você de forma personalizada, leve e estratégica, valorizando resultados reais e duradouros.",

    image: "/assets/images/homepage/hero/dionara-hero-all.png",
    imageAlt: "Dionara Krause - Estética e Nutrição",
    imageVariant: "home-transparent-chair",
    badge: "Atendimento completo",
    floatingText: "Cuidado pensado para você",

    primaryCta: {
      enabled: true,
      label: "Agendar avaliação",
      whatsappKey: "scheduling",
      icon: "whatsapp",
    },

    secondaryCta: {
      enabled: true,
      label: "Explorar serviços",
      to: "/services",
      icon: "sparkles",
    },

    showScrollIndicator: true,
  },

  aesthetics: {
    eyebrow: "Estética avançada • atendimento personalizado",
    title: "Planejamento personalizado para realçar sua beleza natural com segurança e autenticidade",
    description:
      "Procedimentos estéticos pensados para valorizar sua aparência, fortalecer sua autoestima e proporcionar uma experiência leve, segura e personalizada.",

    image: "/assets/images/homepage/hero/dionara-hero-aesthetics.png",
    imageAlt: "Dionara Krause - Estética avançada",
    imageVariant: "home-aesthetics",
    badge: "Atendimento profissional",
    floatingText: "Cuidado pensado para você",

    primaryCta: {
      enabled: true,
      label: "Agendar avaliação",
      whatsappKey: "aesthetics",
      icon: "whatsapp",
    },

    secondaryCta: {
      enabled: true,
      label: "Ver procedimentos",
      to: "/services",
      icon: "sparkles",
    },

    showScrollIndicator: true,
  },

  nutrition: {
    eyebrow: "Nutrição personalizada • saúde com leveza",
    title: "Cuide da sua saúde com estratégia, acolhimento e constância.",
    description:
      "Acompanhamento nutricional pensado para promover saúde, equilíbrio e resultados sustentáveis, respeitando sua rotina, sua individualidade e seus objetivos.",

    image: "/assets/images/homepage/hero/dionara-hero-nutrition.png",
    imageAlt: "Dionara Krause - Nutrição personalizada",
    imageVariant: "home-nutrition",

    badge: "Acompanhamento individual",
    floatingText: "Nutrição adaptada à sua rotina",

    primaryCta: {
      enabled: true,
      label: "Agendar consulta",
      whatsappKey: "nutrition",
      icon: "whatsapp",
    },

    secondaryCta: {
      enabled: true,
      label: "Ver acompanhamentos",
      to: "/services",
      icon: "leaf",
    },

    showScrollIndicator: true,
  },
};

export const aboutPreviewContent = {
  all: {
    eyebrow: "Sobre a Dionara",
    image: "/assets/images/homepage/about/dionara-about.jpg",
    imageAlt: "Dionara Krause",
    titleBefore: "Cuidado que",
    titleEmphasis: "une",
    titleAfter: "beleza, saúde e autoestima",
    paragraphs: [
      "Dionara une estética e nutrição em uma abordagem personalizada, respeitando a história, a rotina e os objetivos de cada paciente.",
      "Seu trabalho busca construir <strong>resultados possíveis, naturais e sustentáveis</strong>, com acompanhamento próximo e uma experiência mais leve."
    ],
    floatingIcon: "person",
    floatingTitle: "Nutrição & Estética Integrada",
    floatingText: "Cuidado completo para corpo, mente e autoestima.",
    features: [
      {
        icon: "person",
        title: "Atendimento Humanizado",
        text: "Você é única, seu cuidado também.",
      },
      {
        icon: "target",
        title: "Planos Personalizados",
        text: "Estratégias adaptadas ao seu momento.",
      },
      {
        icon: "chart",
        title: "Resultados Sustentáveis",
        text: "Beleza, saúde e bem-estar a longo prazo.",
      },
    ],
    button: "Conheça mais sobre a Dionara",
    scriptArrow: "↙",
    scriptText: "Vamos juntas nessa jornada de transformação?",
    stats: [
      {
        icon: "people",
        value: "+1.200",
        label: "pacientes atendidas",
      },
      {
        icon: "badge",
        value: "+8 anos",
        label: "de experiência",
      },
      {
        icon: "heart",
        value: "100%",
        label: "dedicada ao seu cuidado",
      },
    ],
  },

  aesthetics: {
    eyebrow: "Sobre a Dionara",
    image: "/assets/images/homepage/about/dionara-about.jpg",
    imageAlt: "Dionara Krause",
    titleBefore: "Cuidado que",
    titleEmphasis: "transforma",
    titleAfter: "beleza em confiança",
    paragraphs: [
      "Na estética, Dionara conduz cada atendimento com olhar individualizado, valorizando a beleza natural, a autoestima e a harmonia de cada paciente.",
      "Sua abordagem une técnica, escuta e planejamento para criar <strong>resultados elegantes, seguros e naturais</strong>, sem perder a leveza do processo."
    ],
    floatingIcon: "heart",
    floatingTitle: "Estética com propósito",
    floatingText: "Cuidado para realçar sua beleza com naturalidade.",
    features: [
      {
        icon: "person",
        title: "Atendimento Humanizado",
        text: "Você é única, seu tratamento também.",
      },
      {
        icon: "target",
        title: "Protocolos Personalizados",
        text: "Procedimentos alinhados ao seu objetivo.",
      },
      {
        icon: "chart",
        title: "Resultados Naturais",
        text: "Beleza, autoestima e harmonia facial.",
      },
    ],
    button: "Conheça mais sobre a Dionara",
    scriptArrow: "↙",
    scriptText: "Vamos realçar sua beleza com leveza?",
    stats: [
      {
        icon: "people",
        value: "+1.200",
        label: "pacientes atendidas",
      },
      {
        icon: "badge",
        value: "+8 anos",
        label: "de experiência",
      },
      {
        icon: "heart",
        value: "100%",
        label: "foco em autoestima e naturalidade",
      },
    ],
  },

  nutrition: {
    eyebrow: "Sobre a Dionara",
    image: "/assets/images/homepage/about/dionara-about.jpg",
    imageAlt: "Dionara Krause",
    titleBefore: "Cuidado que",
    titleEmphasis: "transforma",
    titleAfter: "de dentro para fora",
    paragraphs: [
      "Dionara conduz o acompanhamento nutricional de forma personalizada, respeitando a história, a rotina e os objetivos de cada paciente para construir <strong>resultados possíveis e sustentáveis.</strong>",
      "Sua atuação une escuta, planejamento e acompanhamento próximo, tornando o <strong>processo mais leve, prático e alinhado</strong> ao estilo de vida de cada pessoa."
    ],
    floatingIcon: "person",
    floatingTitle: "Nutrição personalizada",
    floatingText: "Cuidado alimentar para saúde, equilíbrio e constância.",
    features: [
      {
        icon: "person",
        title: "Atendimento Humanizado",
        text: "Você é única, seu plano também.",
      },
      {
        icon: "target",
        title: "Planos Personalizados",
        text: "Estratégias adaptadas à sua rotina.",
      },
      {
        icon: "chart",
        title: "Resultados Sustentáveis",
        text: "Saúde, autoestima e bem-estar a longo prazo.",
      },
    ],
    button: "Conheça mais sobre a Dionara",
    scriptArrow: "↙",
    scriptText: "Vamos juntas nessa jornada de transformação?",
    stats: [
      {
        icon: "people",
        value: "+1.200",
        label: "pacientes acompanhadas",
      },
      {
        icon: "badge",
        value: "+8 anos",
        label: "de experiência",
      },
      {
        icon: "heart",
        value: "100%",
        label: "dedicada à saúde e transformação de vidas",
      },
    ],
  },
};

export const benefitsByMode = {
  all: {
    eyebrow: "Por que Dionara",
    title: "Por que escolher a experiência com a Dionara?",
    description:
      "Porque cada detalhe da experiência foi pensado para que você se sinta acolhida, segura e bem acompanhada.",
    items: [
      "Atendimento humanizado",
      "Protocolos personalizados",
      "Integração entre estética e nutrição",
      "Planejamento adaptado à sua necessidade",
      "Acompanhamento próximo e atencioso",
      "Experiência pensada para sua confiança",
    ],
  },
  aesthetics: {
    eyebrow: "Por que Dionara",
    title: "Por que escolher a experiência estética com a Dionara?",
    description:
      "Porque cada detalhe foi pensado para que você se sinta acolhida, segura e bem acompanhada em cada etapa do cuidado estético.",
    items: [
      "Atendimento humanizado",
      "Protocolos personalizados",
      "Foco em autoestima, beleza e bem-estar",
      "Planejamento adaptado à sua necessidade",
      "Acompanhamento próximo e atencioso",
      "Resultados naturais e harmônicos",
    ],
  },
  nutrition: {
    eyebrow: "Por que Dionara",
    title: "Por que escolher o acompanhamento nutricional com a Dionara?",
    description:
      "Porque o processo é conduzido com estratégia, escuta e adaptação à sua rotina, tornando a mudança mais leve e sustentável.",
    items: [
      "Atendimento humanizado",
      "Plano alimentar personalizado",
      "Foco em saúde, equilíbrio e constância",
      "Estratégias adaptadas à sua rotina",
      "Acompanhamento próximo e atencioso",
      "Resultados reais sem extremismo",
    ],
  },
};

export const proceduresSectionByMode = {
  all: {
    eyebrow: "Serviços",
    title: "Cuidado completo para ",
    titleAccent: "saúde, estética e bem-estar",

    descriptionBefore: "Conheça os tratamentos e acompanhamentos pensados para atender você de ",
    descriptionBreak: false,
    descriptionAfter: " de forma personalizada e alinhada com",
    descriptionStrong: "forma personalizada.",

    footerButton: "Ver todos os serviços",
  },

  aesthetics: {
    eyebrow: "Procedimentos",
    title: "Tratamentos pensados para valorizar sua beleza com naturalidade",
    titleAccent: "",

    descriptionBefore: "Conheça procedimentos estéticos pensados para realçar sua beleza natural",
    descriptionBreak: false,
    descriptionAfter: " com segurança, leveza e foco no",
    descriptionStrong: "seu objetivo.",

    footerButton: "Ver todos os procedimentos",
  },

  nutrition: {
    eyebrow: "Acompanhamentos",
    title: "Estratégias nutricionais para cuidar da saúde com leveza",
    titleAccent: "",

    descriptionBefore: "Conheça estratégias nutricionais criadas para cuidar da sua saúde",
    descriptionBreak: false,
    descriptionAfter: " respeitando sua rotina, sua individualidade e",
    descriptionStrong: "seu momento.",

    footerButton: "Ver todos os acompanhamentos",
  },
};

export const proceduresData = [
  {
    id: 1,
    modes: ["aesthetics"],
    title: "Toxina Botulínica",
    tag: "Estética facial",
    eyebrow: "Procedimento em evidência",
    badge: "Destaque",
    shortDescription:
      "Suaviza linhas de expressão e promove uma aparência mais leve e natural.",
    description:
      "Procedimento estético voltado para suavizar linhas de expressão e promover uma aparência mais leve, descansada e natural, respeitando a harmonia facial.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar avaliação",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/toxina-botulinica.jpg",
  },
  {
    id: 2,
    modes: ["aesthetics"],
    title: "Preenchimento Labial",
    tag: "Estética facial",
    eyebrow: "Procedimento em evidência",
    badge: "Destaque",
    shortDescription:
      "Mais contorno, definição e equilíbrio para realçar a beleza natural dos lábios.",
    description:
      "Mais contorno, definição e equilíbrio para realçar a beleza natural dos lábios com sofisticação, promovendo harmonia facial e elegância no resultado.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar avaliação",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/preenchimento-labial.jpg",
  },
  {
    id: 3,
    modes: ["aesthetics"],
    title: "Skinbooster",
    tag: "Estética facial",
    eyebrow: "Procedimento em evidência",
    badge: "Destaque",
    shortDescription:
      "Hidratação profunda da pele, promovendo viço, luminosidade e melhora da textura.",
    description:
      "Tratamento voltado para hidratação profunda da pele, promovendo viço, luminosidade, maciez e melhora visível da textura com aspecto natural.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar avaliação",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/skinbooster.jpg",
  },
  {
    id: 4,
    modes: ["aesthetics"],
    title: "Bioestimulador de Colágeno",
    tag: "Estética facial",
    eyebrow: "Procedimento em evidência",
    badge: "Destaque",
    shortDescription:
      "Estimula a produção natural de colágeno, ajudando na firmeza e sustentação da pele.",
    description:
      "Estimula a produção natural de colágeno, ajudando na firmeza, sustentação e qualidade da pele de forma progressiva, elegante e natural.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar avaliação",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/bioestimulador-colageno.jpg",
  },
  {
    id: 5,
    modes: ["aesthetics"],
    title: "Microagulhamento",
    tag: "Estética facial",
    eyebrow: "Procedimento em evidência",
    badge: "Destaque",
    shortDescription:
      "Auxilia na renovação da pele, melhora da textura e estímulo dos processos regenerativos.",
    description:
      "Procedimento que auxilia na renovação da pele, melhora da textura, aparência de marcas, poros e estímulo dos processos regenerativos.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar avaliação",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/microagulhamento.jpg",
  },
  {
    id: 6,
    modes: ["aesthetics"],
    title: "Limpeza de Pele",
    tag: "Estética facial",
    eyebrow: "Procedimento em evidência",
    badge: "Destaque",
    shortDescription:
      "Remoção de impurezas, controle da oleosidade e manutenção da saúde da pele.",
    description:
      "Cuidado essencial para remoção de impurezas, controle da oleosidade, equilíbrio da pele e manutenção da saúde cutânea no dia a dia.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar avaliação",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/limpeza-de-pele.jpg",
  },
  {
    id: 7,
    modes: ["nutrition"],
    title: "Consulta Nutricional",
    tag: "Nutrição",
    eyebrow: "Acompanhamento em evidência",
    badge: "Destaque",
    shortDescription:
      "Avaliação individual para entender sua rotina, objetivos, necessidades e criar um caminho alimentar mais leve, possível e personalizado.",
    description:
      "Consulta voltada para avaliar sua rotina, histórico, exames, objetivos e dificuldades, construindo um plano nutricional mais estratégico e personalizado.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar consulta",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/consulta-nutricional.png",
  },
  {
    id: 8,
    modes: ["nutrition"],
    title: "Plano Alimentar Personalizado",
    tag: "Nutrição",
    eyebrow: "Acompanhamento em evidência",
    badge: "Destaque",
    shortDescription:
      "Estratégias adaptadas à sua rotina, preferências e objetivos.",
    description:
      "Planejamento alimentar construído de forma individual, respeitando preferências, rotina, necessidades clínicas e objetivos, para tornar a alimentação mais prática e sustentável.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar consulta",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/plano-alimentar.jpg",
  },
  {
    id: 9,
    modes: ["nutrition"],
    title: "Emagrecimento com Leveza",
    tag: "Nutrição",
    eyebrow: "Acompanhamento em evidência",
    badge: "Destaque",
    shortDescription:
      "Processo mais leve, possível e sustentável para redução de gordura corporal.",
    description:
      "Acompanhamento com foco em emagrecimento de forma estratégica e sustentável, sem extremismo, com ajustes possíveis para a vida real e acompanhamento próximo.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar consulta",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/emagrecimento.jpg",
  },
  {
    id: 10,
    modes: ["nutrition"],
    title: "Saúde da Mulher",
    tag: "Nutrição",
    eyebrow: "Acompanhamento em evidência",
    badge: "Destaque",
    shortDescription:
      "Cuidado nutricional voltado às fases e necessidades da saúde feminina.",
    description:
      "Estratégias nutricionais para diferentes fases da saúde da mulher, considerando sintomas, exames, rotina, composição corporal e objetivos com uma abordagem individualizada.",
    ctaLabel: "Saber mais",
    ctaHref: "/services",
    secondaryCtaLabel: "Agendar consulta",
    secondaryCtaHref: "/contact",
    image: "/assets/images/homepage/procedures/saude-da-mulher.jpg",
  },
];

export const testimonials = [
  {
    modes: ["aesthetics"],
    name: "Neiva Borba",
    rating: 5,
    text: "Foi maravilhosa! Nara explicou muito bem todo o procedimento e o protocolo a seguir após crio, dando suporte e tirando todas as dúvidas! Gratidão! Super indico excelente profissional e muito atenciosa!",
    avatar: "/assets/images/homepage/testimonials/neiva.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/104490393023827872422/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-27.5113291,-50.3378626,8z/data=!4m6!1m5!8m4!1e1!2s104490393023827872422!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics"],
    name: "Dayana Boehringer",
    rating: 5,
    text: "Gostei muito da avaliação antes do procedimento. A Dionara explicou tudo com calma e sinceridade, sem promessas irreais. Fiz criolipólise e fiquei muito satisfeita com o atendimento. Perdi bastante medidas (as fotos não mentem). Super indico!!!",
    avatar: "/assets/images/homepage/testimonials/dayana.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/102212644544044745084/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-39.9990263,-59.7563292,4z/data=!4m6!1m5!8m4!1e1!2s102212644544044745084!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics"],
    name: "Valdete Da Silva",
    rating: 5,
    text: "Eu fiz sessões de cliopolisese com a Dionara Krause, e tive uma experiência excelente, Atendimento muito profissional, explicações claras e acompanhamento em todas as etapas. Me senti segura e confiante, durante todo o procedimento.",
    avatar: "/assets/images/homepage/testimonials/valdete.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/112721382303649180892/reviews/@-26.894518,-49.0716105,15z/data=!4m3!8m2!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics", "nutrition"],
    name: "Dani Cristin",
    rating: 5,
    text: "Já havia avaliado o atendimento nutricional, que é excelente, e agora voltei para atualizar minha experiência após realizar criolipólise. Tudo começou com uma avaliação cuidadosa, explicações claras e muito profissionalismo. Atendimento humanizado e de muita confiança. Recomendo demais!",
    avatar: "/assets/images/homepage/testimonials/dani.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/106087939057416255055/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-24.9250645,-45.5654634,7z/data=!4m6!1m5!8m4!1e1!2s106087939057416255055!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics", "nutrition"],
    name: "farmacia guilherme & rodrigues",
    rating: 5,
    text: "Ambiente acolhedor, tratamento personalizado! Super indico 🥰",
    avatar: "/assets/images/homepage/testimonials/farmacia_guilherme.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/117437952631847958378/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.9030922,-49.0831575,17z/data=!4m6!1m5!8m4!1e1!2s117437952631847958378!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics", "nutrition"],
    name: "Edjairo Neves Rodrigues",
    rating: 5,
    text: "Além do cuidado com a alimentação, junto vem o cuidado com o todo na estética, assim dando o resultado mais que personalizado!",
    avatar: "/assets/images/homepage/testimonials/edjairo.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/111473401280788776811/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.2128226,-51.8444882,8z/data=!4m6!1m5!8m4!1e1!2s111473401280788776811!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics", "nutrition"],
    name: "Daniel José Lazzaris",
    rating: 5,
    text: "Minha esperiencia foi ótima com esta profissional recomendo muito a quem quer ter uma saúde melhor.",
    avatar: "/assets/images/homepage/testimonials/daniel.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/111128290892589841705/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.908556,-49.0818374,16z/data=!4m6!1m5!8m4!1e1!2s111128290892589841705!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["aesthetics", "nutrition"],
    name: "Rosiane Thayse",
    rating: 5,
    text: "Excelente profissional, super recomendo! Atendimento nota mil. 🎯✅️",
    avatar: "/assets/images/homepage/testimonials/rosiane.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/103775049931319912263/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.9016462,-49.0861872,15z/data=!4m6!1m5!8m4!1e1!2s103775049931319912263!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Cinthia Pruner",
    rating: 5,
    text: "Eu tenho gostado muito e aprendido demais com a Nutri Dionara. Ela tem me ensinado como ter uma relação melhor com a comida, a importância de repor as vitaminas e como pode ser mais prazeroso e leve, cuidar da saúde. Amo. ❤️",
    avatar: "/assets/images/homepage/testimonials/Cinthia.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/110680823947171040923/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.90752,-49.0420424,14z/data=!4m6!1m5!8m4!1e1!2s110680823947171040923!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Ana Luiza Azambuja",
    rating: 5,
    text: "Gostei muito da consulta e da abordagem usada pela Dionara. A avaliação feita é bem detalhada e consegui tirar várias dúvidas. Um dos meus pontos favoritos são as receitinhas que a Nara passa. Super recomendo!",
    avatar: "/assets/images/homepage/testimonials/ana.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/109206906724053183693/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-25.2870832,-50.2197263,8z/data=!4m6!1m5!8m4!1e1!2s109206906724053183693!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Beth",
    rating: 5,
    text: "Recomendo Dionara com total confiança uma ótima profissional... me ajudou muito a ter uma saúde mais saudável e estou muito feliz com o resultado.",
    avatar: "/assets/images/homepage/testimonials/beth.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/118080174486100346016/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.8964886,-49.0935468,15z/data=!4m6!1m5!8m4!1e1!2s118080174486100346016!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Alex Sandro",
    rating: 5,
    text: "Super recomendo, uma profissional que sempre faz o impossível para ajudar cada paciente de forma única, sem aquelas dietas mirabolantes.",
    avatar: "/assets/images/homepage/testimonials/alex.png",
    reviewUrl:
      "https://google.com/maps/contrib/117018582235344424695/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.9514846,-49.0360523,12z/data=!4m6!1m5!8m4!1e1!2s117018582235344424695!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Diana Mamãe de 2",
    rating: 5,
    text: "Ótima profissional, trabalho impecável, sempre se importa com o paciente e faz com que a dieta seja o mais fácil de ser seguida 👏🏻",
    avatar: "/assets/images/homepage/testimonials/diana.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/108641548858050176564/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-27.00131,-48.8568639,11z/data=!4m6!1m5!8m4!1e1!2s108641548858050176564!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Jadna C.A.A. Supis",
    rating: 5,
    text: "Atendimento excelente. Profissional atenciosa, fez plano e orientação personalizados e com bom acompanhamento.",
    avatar: "/assets/images/homepage/testimonials/jadna.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/109734472305649805773/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.9039192,-49.0707122,14z/data=!4m6!1m5!8m4!1e1!2s109734472305649805773!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    modes: ["nutrition"],
    name: "Daniel Souza",
    rating: 5,
    text: "Recomendo muito o trabalho. Nutri muito competente e atenciosa. Com o profissionalismo dela, você vai ter resultados 🙌🏻",
    avatar: "/assets/images/homepage/testimonials/daniel_souza.png",
    reviewUrl:
      "https://www.google.com/maps/contrib/112664862463967090575/place/ChIJh7GQzlcf35QRjw_8xqJ6Wkk/@-26.8959332,-49.0809648,16z/data=!4m6!1m5!8m4!1e1!2s112664862463967090575!3m1!1e1?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  },
];